export const SET_CAL_EVENT_PRODUCT_VALUES_MAX = 2000;
//# sourceMappingURL=set-cal-event-product-values-max.js.map